export default {
  name: "Other Definable Geographic Area(s)",
  prefix: "F.c",
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        isVisible: {
          when: "occupationType",
          is: ["professional_athlete"],
          operator: "||",
        },
        title: "Section Complete",
        description:
          "Because you indicated that this application is for a Professional Athlete, this section is not necessary.",
        type: "success",
      },
    ],
  },
  pageInfo: {
    isVisible: {
      when: "occupationType",
      is: [
        "professional_occupation",
        "non_professional",
        "college_university_teacher",
        "",
      ],
      hideStyles: true,
      operator: "||",
    },
    text: `<b>IMPORTANT:</b> Complete this question only where the specific MSA(s) are not known or the expected area(s) of intended employment are dispersed over a wide geographical area. if submitting this form non-electronically, and not applicable, enter "N/A". If the job opportunity requires roving, travel or possible relocation, enter the phrase "Various Worksites", otherwise, enter "N/A".`,
    coloring: "grey",
  },
  sections: [
    {
      isVisible: {
        when: "occupationType",
        is: [
          "professional_occupation",
          "non_professional",
          "college_university_teacher",
          "",
        ],
        hideStyles: true,
        operator: "||",
      },
      fields: [
        {
          code: "F.c.1",
          machine_name: "geograpicalArea",
          label:
            "Identify the geographic area(s) where work will be performed. For example, this can include a listing of cities or townships/states, counties/states, or states located within a geographic region (up to 1,500 characters). §",
          tooltip:
            "Complete this question if the MSA(s) for the employer’s job opportunity are not known <b><u>or</u></b> are dispersed over a wide geographical area <b><u>or</u></b> additional details regarding the geographic area(s) where work will be performed is needed (e.g., work itinerary, listing of cities or townships/states, counties/states, or several states).  If the job opportunity requires roving, travel or possible relocation; enter the phrase “Various Worksites,’ otherwise, enter “N/A.” ",
          widget: "text_area",
          validate: [
            {
              isRequired: "primaryWorksiteType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "4",
              },
            },
            {
              minLengthWithNA: 5,
              message: "F.c.1 must contain at least 5 characters",
            },
          ],
          inputLimit: 1500,
          width: 8,
          rows: 8,
        },
      ],
    },
  ],
};
